import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=b4c4b066&scoped=true&"
import script from "./NotFound.vue?vue&type=script&lang=ts&"
export * from "./NotFound.vue?vue&type=script&lang=ts&"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=b4c4b066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c4b066",
  null
  
)

export default component.exports